<button type="button" class="scroll-to-top-btn" [class.visible]="isVisible" (click)="scrollToTop()"
  aria-label="Voltar ao início da página" title="Voltar ao início da página">
  <i class="fas fa-arrow-up"></i>
</button>